import { useQuery } from '@apollo/client'
import { SortByType } from '../../constants'
import { UserLogsFilterInput, UserLogs, UserLogsVariables, SortDirectionEnum } from '../../types'
import { USER_LOGS } from './operations'

interface Props {
  filter: UserLogsFilterInput
  page: number
  pageLength: number
  direction: SortDirectionEnum
  sortBy?: SortByType | string
}

export const useUserLogs = ({ filter, page, pageLength, direction, sortBy }: Props) =>
  useQuery<UserLogs, UserLogsVariables>(USER_LOGS, {
    variables: {
      filterData: {
        ...filter,
      },
      pagination: {
        from: pageLength * (page - 1),
        length: pageLength,
        direction,
        sortBy,
      },
    },
  })
